
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-quote",
      function () {
        return require("private-next-pages/get-quote/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-quote"])
      });
    }
  